import React, { useMemo, useState } from 'react'
import styled from 'styled-components'
import BigNumber from 'bignumber.js'
import { Text, Flex, Button, AutoRenewIcon } from 'uikit'
import { useTranslation } from 'contexts/Localization'
import useTokenBalance from 'hooks/useTokenBalance'
import { getDmdAddress } from 'utils/addressHelpers'
import { getBalanceAmount, getDecimalAmount } from 'utils/formatBalance'
import { FormCon, FormLeft, FormInput, Max } from '../styled'
import useStakeMultiPool from '../hooks/useStakeMultiPool'

const StakeButton = styled(Button)`
  background: #8E12FC;
  border-radius: 0px 6px 6px 0px;
  height: unset;
  width: 100px;
  font-size: 15px;
`

const StakeForm: React.FC = () => {
  const { t } = useTranslation()
  const { balance: dmdBalance } = useTokenBalance(getDmdAddress())
  const { isStaking, handleStakeMultiPool } = useStakeMultiPool()
  const [stakeAmount, setStakeAmount] = useState('')

  const dmdBalanceString = useMemo(() =>
    getBalanceAmount(dmdBalance).toString(),
    [dmdBalance],
  )

  const dmdBalanceDisplay = useMemo(() =>
    getBalanceAmount(dmdBalance).toFixed(3),
    [dmdBalance],
  )

  const disableStake = useMemo(() => (
    stakeAmount === '' ||
    getDecimalAmount(new BigNumber(stakeAmount)).isLessThanOrEqualTo(0) ||
    getDecimalAmount(new BigNumber(stakeAmount)).isGreaterThan(dmdBalance) ||
    isStaking
  ), [stakeAmount, dmdBalance, isStaking])

  return (
    <FormCon>
      <FormLeft>
        <Flex justifyContent="space-between">
          <Text fontSize="15px" fontWeight={300}>
            {t('DMD Available')}
          </Text>
          <Text fontSize="15px" fontWeight={300}>
            {dmdBalanceDisplay}
          </Text>
        </Flex>
        <Flex justifyContent="space-between" mt="2px" alignItems="center">
          <FormInput
            placeholder="0.0"
            value={stakeAmount}
            onChange={({ target }) => setStakeAmount(target.value)}
            type="number"
          />
          <Max onClick={() => setStakeAmount(dmdBalanceString)}>{t('Max')}</Max>
        </Flex>
      </FormLeft>
      <StakeButton
        disabled={disableStake}
        onClick={() => handleStakeMultiPool(stakeAmount)}
        isLoading={isStaking}
        endIcon={isStaking ? <AutoRenewIcon spin color="currentColor" /> : null}
      >
        {isStaking ? t('Staking') : t('Stake')}
      </StakeButton>
    </FormCon>
  )
}

export default StakeForm
